import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from './../../components/common/datatables/datatable.module';
import { ModalModule } from 'ng2-bootstrap';
import {RouterModule} from "@angular/router";

import {UsersListComponent} from "./users-list.component";
import {UsersOneComponent} from "./user-one/user-one.component";
import {UserRemoveConfirmComponent} from './user-remove-confirm/user-remove-confirm.component';
import {UsersService} from "../../models/users/users.service";
import {CompaniesService} from "../../models/companies/companies.service";
import {SelectpickerModule} from "../../directives/selectpicker/selectpicker.module";
import {ConfirmModule} from '../../modules/confirm/confirm.module';

@NgModule({
    declarations: [UsersListComponent, UsersOneComponent, UserRemoveConfirmComponent],
    imports     : [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        ModalModule,
        RouterModule,
        SelectpickerModule,
        ConfirmModule
    ],
    providers: [
        UsersService,
        CompaniesService
    ]
})

export class UsersModule {}


// WEBPACK FOOTER //
// ./src/app/views/users/users.module.ts